import React, { useState } from 'react';

const PREVIEW_LENGTH = 80;

const ProfileBio = ({ bio, className }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!bio) {
    return null; 
  }

  const needsTruncation = bio.length > PREVIEW_LENGTH;
  
  const bioText = (isExpanded || !needsTruncation) 
    ? bio 
    : `${bio.substring(0, PREVIEW_LENGTH)}... `;

  return (
    <div className={`w-full px-6 text-center transition-colors ${className || ''}`}>
      {/* ✅ Softened the text color for dark mode readability */}
      <p className="text-sm text-gray-700 dark:text-brand-white/80 whitespace-pre-wrap leading-relaxed">
        {bioText}
        
        {/* ✅ "Read More" Button: Now uses Brand Pink in dark mode for visibility */}
        {!isExpanded && needsTruncation && (
          <button 
            onClick={() => setIsExpanded(true)} 
            className="text-gray-900 dark:text-white/80 font-bold ml-1 hover:underline cursor-pointer"
          >
            read more
          </button>
        )}

        {/* ✅ "See Less" Button: Matching the pink highlight */}
        {isExpanded && needsTruncation && (
          <button 
            onClick={() => setIsExpanded(false)} 
            className="text-gray-900 dark:text-[#ff00cc] font-bold ml-1 hover:underline cursor-pointer"
          >
            see less
          </button>
        )}
      </p>
    </div>
  );
};

export default ProfileBio;